<script>
    import f9link from "inputs/f9link.vue";

    export default {
        props: {
                cdnHost: {
                    type: String,
                    default: "//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net"
                }
        },
        components: {
            f9link
        }
    }
</script>

<template>
    <div class="signup-frontiermiles-container">
        <div class="signup-frontiermiles-logo">
            <img :src="cdnHost + '/images/FrontierMileslogo.svg'" alt="Frontier Miles">
        </div>
        <div class="signup-p">Join our free loyalty program and start earning today!</div>

        <div class="signup-legend text-small">
            <f9link href="https://www.flyfrontier.com/frontiermiles" target="_blank">Learn More</f9link>
        </div>

        <div class="signup-info-header green-background">
            <div >
                <strong>Earn FREE Flights, Bags, Seats & More!</strong>
            </div>
        </div>
        <div class="signup-info signup-images">
            <div class="signup-image">
                <img :src="cdnHost + '/images/Icon_RGBMarkers.svg'" alt="">
                <div class="signup-images-text-container">
                    <span class="signup-images-large-text">Earn 10X miles</span>
                    <span class="signup-images-small-text">Earn 10X qualifying miles for every eligible dollar spent with Frontier, up to 20X miles for <i>FRONTIER Miles</i> Diamond members.</span>
                </div>
            </div>
            <div class="signup-image">
                <img :src="cdnHost + '/images/Icon_BluebackgroundStar.svg'" alt="">
                <div class="signup-images-text-container">
                    <span class="signup-images-large-text">Easy-to-get Status</span>
                    <span class="signup-images-small-text">Get Elite Status with only 10,000 qualifying miles, or $1,000 on any Frontier purchase!</span>
                </div>
            </div>
            <div class="signup-image">
                <img :src="cdnHost + '/images/Icon_GreenPlane.svg'" alt="">
                <div class="signup-images-text-container">
                    <span class="signup-images-large-text">Get FREE Flights</span>
                    <span class="signup-images-small-text">A FREE one-way award ticket starts at just 10,000 miles! Now you can get free flights faster with more ways to earn.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .signup-frontiermiles-container {
        .signup-frontiermiles-logo {
            img {
                width: 350px;
            }
        }
        
        .signup-p {
            margin-top: 5px;
        }

        .signup-info-header {
            font-size: 24px;
            margin-bottom: 6px;
            font-weight: 400;
            line-height: 45px;
            padding-left: 17px;
            
            /* TODO Verify this is what marketing wants */
            /* position: -webkit-sticky;
            position: sticky;
            top: 0px;
            z-index: 1001 !important; */
        }

        .signup-images {
            display: flex;
            justify-content: space-around;
            background-color: @ibe-background--light-gray;
            border-style: none !important;

            .signup-image {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0 2px;
                width: 100%;

                .signup-images-text-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                }

                .signup-images-text-container span {
                    text-align: center;
                    margin-bottom: 3px;
                    width: 100%;
                }

                img {
                    width: 100px;
                    height: 100px;
                    min-width: 40px;
                    min-height: 40px;
                    margin-bottom: 10px;
                }

                .signup-images-large-text {
                    font-size: 16px;
                    font-weight: 600;
                    color: @frontier-gray-xxdark;
                }

                .signup-images-small-text {
                    font-size: 12px;
                    color: @ibe-text--light-bluegray;
                }

                a {
                    color: @frontier-green;
                    font-weight: 600;
                    font-size: 12px;
                }
            }
        }

        .signup-info {
            padding: 17px 24px 12px;
            border-style: solid;
            border-width: 1px;
            border-color: hsla(0, 0%, 43%, .25);
            box-sizing: border-box;
        }

        .signup-legend {
            text-align: right;
            margin-top: 10px;
            margin-bottom: 5px;
        }

        .text-small {
            font-size: 12px;
        }
    }

    @media @tablet {
        .signup-frontiermiles-container {
            .signup-frontiermiles-logo {
                img {
                    width: 200px;
                }
            }

            .signup-p {
                font-size: 12px;
            }

            .signup-images {
                flex-direction: column;

                .signup-image {
                    flex-direction: row;

                    img {
                        width: 40px;
                        height: 40px;
                    }

                    .signup-images-text-container {
                        flex-direction: column;
                        align-items: flex-start;
                        margin-left: 7px;
                        margin-bottom: 10px;

                        span {
                            text-align: start;
                            margin-bottom: 0;
                        }

                        .signup-images-large-text {
                            font-size: 12px;
                        }

                        .signup-images-small-text {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
    }


</style>